/**
 * Base error class for all application errors.
 * Extends the standard Error class with additional properties and methods.
 */
export class AppError extends Error {
  /**
   * The error code, which can be used to identify the error type.
   */
  public readonly code: string;

  /**
   * Additional data related to the error.
   */
  public readonly data?: any;

  /**
   * Whether the error is operational (expected) or programming (unexpected).
   * Operational errors are expected errors that can occur during normal operation
   * (e.g., validation errors, not found errors).
   * Programming errors are unexpected errors that indicate a bug in the code
   * (e.g., TypeError, ReferenceError).
   */
  public readonly isOperational: boolean;

  /**
   * Creates a new AppError instance.
   * @param message The error message.
   * @param code The error code.
   * @param isOperational Whether the error is operational (expected) or programming (unexpected).
   * @param data Additional data related to the error.
   */
  constructor(
    message: string,
    code: string = 'INTERNAL_ERROR',
    isOperational: boolean = true,
    data?: any
  ) {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
    this.isOperational = isOperational;
    this.data = data;

    // Capture stack trace, excluding the constructor call from the stack trace
    Error.captureStackTrace(this, this.constructor);
  }
}